import OptionsPane from "./OptionsPane";
import PreferencesPane from "./PreferencesPane";
import PreferencesPaneSelectField from "./PreferencesPaneSelectField";
import PreferencesPaneToggleField from "./PreferencesPaneToggleField";
import PreferencesPaneTogglesField from "./PreferencesPaneTogglesField";

export default PreferencesPane;
export {
  OptionsPane,
  PreferencesPane,
  PreferencesPaneSelectField,
  PreferencesPaneToggleField,
  PreferencesPaneTogglesField,
};
